import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';

const DelayedTasks = ({ tasks }) => {
    const count = tasks?.length || 0;

    return (
        <div className="bg-white rounded-2xl p-6 shadow-md">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-gray-900">Delay At Start</h3>
                <span className="text-[#D32F2F] text-lg font-bold">{String(count).padStart(2, '0')}</span>
            </div>

            {/* Haven't Started Section */}
            <div className="mb-4">
                <div className="bg-[#FFDAD9] rounded-lg px-4 py-3 flex items-center mb-2">
                    <AlertCircle size={28} className="text-white fill-[#D32F2F] mr-3" />
                    <div>
                        <div className="text-[#5D1D1D] font-semibold text-base">Delay At Start ({count})</div>
                        <div className="text-[#8C5D5D] text-xs">Work not begun yet</div>
                    </div>
                </div>
                {tasks?.length > 0 ? (
                    <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto pr-1 custom-scrollbar">
                        {tasks.map((task) => (
                            <div
                                key={task.id}
                                className="bg-white border border-[#FFDAD9] rounded-lg px-4 py-3 flex items-start shadow-sm"
                            >
                                <XCircle size={20} className="text-[#D32F2F] mr-3 mt-0.5 flex-shrink-0" />
                                <div className="flex flex-col gap-1">
                                    <span className="text-sm text-gray-700 font-medium">{task.name}</span>
                                    {task.workType?.name && (
                                        <span className="text-xs text-red-700 bg-red-100 px-2 py-0.5 rounded w-fit">
                                            {task.workType.name}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center py-10 px-4">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-green-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            No Delays At Start
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            Excellent! All tasks have started on time today. Keep up the great work!
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DelayedTasks;
